/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsSignUpResponse
 */
export interface RevisdomAPIViewModelsSignUpResponse {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignUpResponse
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsSignUpResponse
     */
    role?: RevisdomAPIViewModelsSignUpResponseRoleEnum;
}


/**
 * @export
 */
export const RevisdomAPIViewModelsSignUpResponseRoleEnum = {
    Admin0: 'Admin (0)',
    Editor1: 'Editor (1)',
    Commenter2: 'Commenter (2)',
    Viewer3: 'Viewer (3)',
    SperYnetici4: 'Süper Yönetici (4)',
    Guest5: 'Guest (5)'
} as const;
export type RevisdomAPIViewModelsSignUpResponseRoleEnum = typeof RevisdomAPIViewModelsSignUpResponseRoleEnum[keyof typeof RevisdomAPIViewModelsSignUpResponseRoleEnum];


/**
 * Check if a given object implements the RevisdomAPIViewModelsSignUpResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsSignUpResponse(value: object): value is RevisdomAPIViewModelsSignUpResponse {
    return true;
}

export function RevisdomAPIViewModelsSignUpResponseFromJSON(json: any): RevisdomAPIViewModelsSignUpResponse {
    return RevisdomAPIViewModelsSignUpResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsSignUpResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsSignUpResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function RevisdomAPIViewModelsSignUpResponseToJSON(json: any): RevisdomAPIViewModelsSignUpResponse {
    return RevisdomAPIViewModelsSignUpResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsSignUpResponseToJSONTyped(value?: RevisdomAPIViewModelsSignUpResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'role': value['role'],
    };
}

